export const SORT_OPTIONS_VALUES = {
    DISCONNECTED_FIRST: 'Disconnected',
    CONNECTED_FIRST: 'Connected',
};

export const CONNECTION_STATUS = {
    CONNECTED: 'Connected',
    DISCONNECTED: 'Disconnected',
};

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = [10, 20, 30, 50];
export const MAX_DATE_RANGE_DAYS = 90;
export const CONNECTED_COLOR = 'rgba(0, 81, 255, 0.32)';
export const DISCONNECTED_COLOR = 'rgba(0, 0, 0, 0.40)';
export const ROW_HEIGHT = 24;
export const CHART_PADDING_BOTTOM = 65;
export const CHART_PADDING_BOTTOM_WITH_NAV = 155;
export const MAX_NAVIGATOR_RANGE_MS = 14 * 24 * 3600 * 1000;
export const NAVIGATOR_TOOLTIP_DURATION_MS = 5000;

